/* eslint-disable no-undef */
import React, { useEffect } from "react";
import { object } from "prop-types";

import HomeCarousel from "../../molecules/home-carousel";

import "./home-carousel.m.css";

const HomeCarouselRow = ({ collection }) => {
  useEffect(() => {
    const header = document.getElementById("header");

    if (!header) return;
    const floatingHeader = document.getElementById("floating-donate-button");

    const observer = new IntersectionObserver(
      ([entry]) => {
        entry.isIntersecting ? (floatingHeader.style.display = "none") : (floatingHeader.style.display = "block");
        console.log("hello", floatingHeader);
      },
      { threshold: 0 }
    );

    observer.observe(header);

    return () => observer.disconnect();
  }, []);

  return (
    <div styleName="wrapper">
      <div id="floating-donate-button" styleName="floating-donate-btn">
        <a href="/support">
          <button styleName="donate-button fixed">DONATE</button>
        </a>
      </div>
      <HomeCarousel
        collection={collection}
        options={{
          type: "carousel",
          perView: 1,
          gap: 24,
          autoplay: false // Re-enable after October 17 (disabled for NCF festival banner)
        }}
      />
    </div>
  );
};

HomeCarouselRow.propTypes = {
  collection: object.isRequired
};

export default HomeCarouselRow;
